import styled from "@emotion/styled";

export const Container = styled.div`
  display: flex;
  padding: 40px;
  flex-direction: column;
  align-items: flex-start;
  gap: 20px;
  position: relative;
`;

export const TitleContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  padding-bottom: 20px;
  width: 100%;

  border-bottom: 1px solid var(--alias-color-line-normal);
`;

export const ContentContainer = styled.div`
  display: flex;
  flex-direction: column;
`;

export const SelectionContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  gap: 8px;
  margin-top: 16px;
  margin-bottom: 20px;
`;

export const ItemContainer = styled.div`
  display: flex;
  padding: 16px;
  flex-direction: column;
  align-items: flex-start;
  gap: 8px;
  align-self: stretch;

  border-radius: 10px;
  border: 1px solid var(--alias-color-line-normal);
  background: var(--alias-color-background-normal-normal);
  cursor: pointer;
`;

export const CheckboxContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

export const BtnContainer = styled.div`
  display: flex;
  gap: 12px;
  flex: 1;
`;

export const CancelIconContainer = styled.div`
  display: flex;
  position: absolute;
  right: 20px;
  top: 20px;
`;
